import {
  QuestionSection,
  UserAssessmentProgress,
} from '@osmosis/shared/types/learndb/learnData';
import { getNameFromTagSet } from '@osmosis/shared/quiz';
import { LanguageCode } from '@osmosis/shared/languages';

import { QuestionSet } from '../../types/questions';

const localizeQbankDisplayName = ({
  path,
  language = LanguageCode.EN,
  overriddenNames,
}: {
  path: string;
  language?: LanguageCode;
  overriddenNames?: { [key: string]: string };
}) => {
  if (language === LanguageCode.EN || !overriddenNames) return null;
  return overriddenNames?.[path] || null;
};

/**
 * .
 */
export const extractQuestionSets = (
  learnQuestions?: QuestionSection,
  language?: LanguageCode,
  overriddenNames?: { [path: string]: string },
  assessmentProgress: UserAssessmentProgress['questions'] = {},
): QuestionSet[] => {
  if (!learnQuestions) return [];

  const questions = Object.entries(learnQuestions || {})
    .map(([key, value]) => ({
      ...value,
      key,
      name: `${getNameFromTagSet(key)} questions`,
      localizedName: localizeQbankDisplayName({
        language,
        overriddenNames,
        path: key,
      }),
      progress: assessmentProgress?.[key],
    }))
    .filter((ques) => ques.list.length);

  return questions;
};

/**
 * .
 */
export function isString(s: any): s is string {
  return typeof s === 'string';
}

/**
 * .
 */
export function getStringProperty(
  obj: string | { [index: string]: string } | undefined,
  key: string,
): string {
  if (!obj) return '';

  let str = '';
  if (isString(obj)) str = obj;
  else if (isString(obj?.[key])) str = obj?.[key];

  return str;
}
